import React from "react";
import { Typography } from "@mui/material";
import PhoenixShortHeader from "../PhoenixShortHeader/PhoenixShortHeader";
import AvailablePhoenixShort from "../AvailablePhoenixShort/AvailablePhoenixShort";

const PhoenixShort = () => {
  document.title = "Phoenix Short Syllabus ~ Physics Of Stupid";
  return (
    <div>
      <PhoenixShortHeader></PhoenixShortHeader>

      <Typography
        sx={{ mt: "10px" }}
        variant="button"
        display="block"
        gutterBottom
      >
        Phoenix Short Syllabus~ Let's Go to Chander Deshe 🚀
      </Typography>
      <AvailablePhoenixShort></AvailablePhoenixShort>
    </div>
  );
};

export default PhoenixShort;
